import React from 'react';

import auth, { Auth } from './modules/auth';
import booking, { Booking } from './modules/booking';

export type RootStore = {
  auth: Auth;
  booking: Booking;
};

export const store: RootStore = {
  auth,
  booking
};

const StoreContext = React.createContext<RootStore>(store);

export const StoreProvider = StoreContext.Provider;

export const useStore = () => React.useContext(StoreContext);

export { auth };
